const ITEMS = [
  "KINGSTON → TORONTO",
  "KINGSTON → SHANGHAI",
  "KINGSTON → MIAMI",
  "KINGSTON → CARIBBEAN",
  "30 YEARS OF TRUSTED CARGO MOVEMENT",
  "LICENSED CUSTOMS BROKER",
];

export const Marquee = () => {
  const content = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="trade-lanes-marquee"
      className="relative bg-deep-surface border-y border-gold/15 overflow-hidden py-4"
    >
      <div className="marquee-track">
        {[0, 1].map((rep) => (
          <div key={rep} className="flex items-center shrink-0">
            {content.map((item, i) => (
              <span
                key={`${rep}-${i}`}
                className="font-display text-sm sm:text-base tracking-wide text-[#A1B0A6] px-6 sm:px-8 whitespace-nowrap"
              >
                {item}
                <span className="text-gold ml-6 sm:ml-8">&bull;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
